<template>
  <div class="anchor">
    <div
      class="notifications-container"
      :class="{ topBarOffset: !topBarStore.removeTopBar }"
    >
      <transition-group name="list-complete" tag="div">
        <Notification
          v-for="notification in notificationsStore.notifications"
          :key="notification.id"
          class="list-complete-item"
          :notification="notification"
        />
      </transition-group>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import Notification from "./_internal/Notification.vue";
  import { useNotificationsStore } from "@/stores/notifications";
  import { useTopBarStore } from "@/stores/topBar";

  const notificationsStore = useNotificationsStore();
  const topBarStore = useTopBarStore();
</script>

<style lang="scss">
  .anchor {
    position: relative;
  }

  .notifications-container {
    position: fixed;
    z-index: 9999999;
    top: 0;
    right: 0;

    &.topBarOffset {
      top: 54px;
    }
  }

  .list-complete-item {
    display: flex;
    margin-right: 20px;
  }

  .list-complete-enter-active,
  .list-complete-leave-active {
    transition: all 0.5s ease;
  }
  .list-complete-enter-from,
  .list-complete-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
</style>
